/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import moment from 'moment';
import {
  all, call, put, takeEvery,
} from 'redux-saga/effects';

import { request } from 'utils/request';
import { IRestApiResponse } from 'interfaces';
import API from './constants';
import { schedulesActions } from './slice';
import {
  CancelSession, IGenerateSessionStateAction, GetScheduleByDate, ISchedule,
} from './interface';

const processScheduleData = async (data: any): Promise<any> => {
  const schedulesOfTheMonth: ISchedule[] = [];

  data.forEach((session: any) => {
    if (session?.meta?.slot) {
      schedulesOfTheMonth.push({
        ...session,
        from: moment(session.meta.slot.from).format('hh:mm A'),
        to: moment(session.meta.slot.to).format('hh:mm A'),
        date: moment(session.meta.slot.from).format('YYYY-MM-DD'),
      });
    }
  });

  return schedulesOfTheMonth;
};

export function* getSchedulesListGenerator({ payload }: GetScheduleByDate): any {
  try {
    const response: IRestApiResponse = yield call(
      request,
      {
        path: `${API.GET_SCHEDULES.path}?from=${payload.from}&to=${payload.to}`,
        method: API.GET_SCHEDULES.method,
      },
      {},
      true,
      false,
    );
    if (response.statusCode === 200) {
      const procssedData = yield call(processScheduleData, response.data);
      yield put(schedulesActions.getScheduleListSucceeded(procssedData));
    } else {
      yield put(schedulesActions.getScheduleListFailed());
    }
  } catch (error) {
    yield put(schedulesActions.getScheduleListFailed());
  }
}

export function* getSessionUrlGenerator({ payload }: IGenerateSessionStateAction) {
  try {
    const response: IRestApiResponse = yield call(
      request,
      { path: API.GET_SESSION_URL.path, method: API.GET_SESSION_URL.method },
      { ...payload },
      true,
      false,
    );

    if (response.statusCode === 201) {
      yield put(schedulesActions.getSessionUrlSuccessed(response.data));
    } else {
      yield put(schedulesActions.getSessionUrlFailed());
    }
  } catch (error) {
    yield put(schedulesActions.getSessionUrlFailed());
  }
}

export function* cancelSessionGenerator({ payload }: CancelSession) {
  try {
    const response: IRestApiResponse = yield call(
      request,
      { path: `${API.POST_CANCEL_SESSION.path}/${payload.id}`, method: API.POST_CANCEL_SESSION.method },
      { meetingId: payload.meetingId },
    );

    if (response.statusCode === 201) {
      yield put(schedulesActions.cancelSessionSuccess());
      if (payload?.resolve) {
        yield payload.resolve();
      }
    } else {
      yield put(schedulesActions.cancelSessionFailed());
      if (payload?.reject) {
        yield payload.reject();
      }
    }
  } catch (error) {
    yield put(schedulesActions.cancelSessionFailed());
    if (payload?.reject) {
      yield payload.reject();
    }
  }
}

export function* schedulesSaga() {
  yield all([
    takeEvery(schedulesActions.getScheduleList.type, getSchedulesListGenerator),
    takeEvery(schedulesActions.getSessionUrl.type, getSessionUrlGenerator),
    takeEvery(schedulesActions.cancelSession.type, cancelSessionGenerator),
  ]);
}

export default schedulesSaga;
